"use strict";

import {findIn, on} from "@elements/dom-utils";
import {onFind} from "@elements/init-modules-in-scope";
import {createSwiper} from "./swiper";

export function init () {

    onFind('.js-gallery', function (sliderElement) {

        let slidesPerViewDesktop = 1,
            slidesPerViewMobile = 1;

        let swiperEl = createSwiper(sliderElement,{
                // mediaQuery: '(max-width: 767px)',
                loop: false,
                slidesPerView: slidesPerViewMobile,
                breakpoints: {
                    // when window width is >= 768px
                    768: {
                        slidesPerView: slidesPerViewDesktop
                    }
                },
                navigation: {
                    findNextElement: swiperContainer => findIn('.js-gallery__next', swiperContainer),
                    findPrevElement: swiperContainer => findIn('.js-gallery__prev', swiperContainer),
                },
            },
            {
                sliderContainer: '.js-gallery',
                slider: '.js-gallery__slider',
                sliderPrev: '.js-gallery__prev',
                sliderNex: '.js-gallery__next',
                sliderIndex: '.js-gallery__current-index'
            });
    });
    
}